import mori from 'mori';
import { indexOf } from '../../util/util';

/**
 * Compose the footnotes into an array of hashmaps with the following keys:
 * Should be a composed key:
 * * [year, location, headergroup]
 * * [year, location, header]
 * * [year, location, #{headergroup, header}]
 *
 * @param  {mori.vector} footnotes  [footnotes from config]
 * @param  {mori.vector} timeframes [active timeframes to use]
 * @param  {mori.vector} distributions [active distributions to use]
 * @return {mori.vector}            [vector of composed footnote keys]
 */
export default function composeFootnotes(footnotes, timeframes, distributions) {
  const getLocationSplit = (location) => location.match(/^([^[]+)\[(.*)\]$/);

  return mori.reduceKV(
    (acc, year, yearData) => (
      indexOf(timeframes, year) ?
      mori.into(
        acc,
        mori.reduceKV(
          (acc1, state, stateData) => mori.into(
            acc1,
            mori.reduceKV(
              (acc2, dist, distData) => {
                if (indexOf(distributions, dist)) {
                  // For footnotes with:  California[Exact_value]
                  // Split the state and send back the value as well
                  // to match on the exact table cell for the footnote;
                  const locationSplit = getLocationSplit(state);
                  return mori.conj(
                    acc2,
                    mori.hashMap(
                      locationSplit ?
                      mori.set([
                        year,
                        locationSplit[1],
                        dist,
                        locationSplit[2],
                      ]) :
                      mori.set([year, state, dist]),
                      distData,
                    )
                  );
                }

                return acc2;
              },
              mori.vector(),
              stateData
            )
          ),
          mori.vector(),
          yearData
        )
      ) :
      acc
    ),
    mori.vector(),
    footnotes
  );
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/getFootnotes/composeFootnotes.js
 **/